/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import componentTypes from '@data-driven-forms/react-form-renderer/dist/cjs/component-types';
import moment from 'moment';
import { formatISOStringForView } from './stringFormat';

export const formatters = {
  [componentTypes.DATE_PICKER]: formatISOStringForView, // @ts-ignore
  [componentTypes.PLAIN_TEXT]: ({ value, options, dateFormat }) => {
    if (dateFormat) {
      return value ? moment.utc(value).format(dateFormat) : value;
    } else if (options) {
      // @ts-ignore
      return options.find(({ value: optionValue }) => optionValue === value)?.label || '';
    } else {
      return value;
    }
  }, // @ts-ignore
  [componentTypes.SELECT]: ({ value, options }) =>
    // @ts-ignore
    options?.find(({ value: optionValue }) => optionValue === value)?.label || ''
};
